// extracted by mini-css-extract-plugin
export default {"reasonDropdown":"CancelContractModal_reasonDropdown__PW+sg","modalContainer":"CancelContractModal_modalContainer__Juo4g"};